import { useGetAccountQuery } from '@/services/accounts';
import { useParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { LoopFieldGeothermalPackage } from './LoopFieldGeothermalPackage';

export const LoopFieldMilestonePackageFactory = ({
  canSubmitPackage = true,
}: {
  canSubmitPackage?: boolean;
} = {}) => {
  const { id } = useParams<{ id: any }>();
  const { data: account } = useGetAccountQuery(id);

  switch (account?.programType) {
    case ProgramType.geothermal:
      return <LoopFieldGeothermalPackage canSubmitPackage={canSubmitPackage} />;
    default:
      return null;
  }
};
